export const CONSTANTS = {
    roles: [{
        value: "student",
        label: "Student",
    },
    {
        value: "tutor",
        label: "Tutor",
    }
    ],
    errorMsgs: {
        400: "Email already exists, please use another.",
        401: "Email or password does not match.",
        500: "Something went wrong. Please try again."
    },
    subscriptionType: [
        {
            name: 'BASIC',
            features: [
                "Limited PDF Access",
                "Storage for uploading documents: 400MB",
                "Page views per month: 300"
            ]
        },
        {
            name: 'PREMIUM',
            features: [
                "PRO PDF Access",
                "Storage for uploading documents: 1GB",
                "Page views per month: 1000"
            ]
        }
    ],
    durationObj: {
        '7': '1 week',
        '30': '1 month',
        '90': '3 months',
        '180': '6 months',
        '360': '1 Year',
    },
    maxImageZoom: 1200,
    minImageZoom: 200,

    examTypeList: [
        {
            name: 'ABSITE',
            value: 'ABSITE'
        },
        {
            name: 'Step 1',
            value: 'Step_1'
        },
        {
            name: 'Step 2',
            value: 'Step_2'
        },
        {
            name: 'Step 3',
            value: 'Step_3'
        },
        {
            name: 'MCAT',
            value: 'MCAT'
        },
        {
            name: 'COMLEX',
            value: 'COMLEX'
        },
        {
            name: 'OMM',
            value: 'OMM'
        },
        {
            name: 'ABR Core',
            value: 'ABR_CORE'
        },
        {
            name: 'ABIM',
            value: 'ABIM'
        },
        {
            name: 'ABFM',
            value: 'ABFM'
        }
    ],
    planStatusType: [{
        name: 'Active',
        value: 'ACTIVE'
    }, {
        name: 'Inactive',
        value: 'INACTIVE'
    }, {
        name: 'Deprecated',
        value: 'DEPRECATED'
    }],
    powerSearch: true,
    powerSearchAutoComplete: true,
    powerSearchCharLength: 4,
    thresholdFeatureEnabled: true,
    // Semantic "Search by meaning" affordance. Off unless the env flag is set to
    // "true", so the UI stays dark until the backend flag is enabled per-env.
    semanticSearchEnabled: process.env.REACT_APP_ENABLE_SEMANTIC_SEARCH === "true",
    // Tutor<->student mentorships (view-only follow + request/accept). Off unless
    // the env flag is set; the /mentorships route stays dark until the backend
    // endpoints land (a nav entry point is a follow-up). See
    // docs/qlearn-tutor-student-sharing-design.md.
    mentorshipsEnabled: process.env.REACT_APP_ENABLE_MENTORSHIPS === "true",
    // Student→tutor question tags (design §10, tech-med/Qlearn-UI#512). Sub-flag
    // of mentorships: the tag UI renders only when BOTH this and
    // mentorshipsEnabled are true, mirroring the backend's two-flag gate
    // (qlearn.mentorship.enabled + qlearn.mentorship.tags.enabled). Dark by default.
    mentorshipTagsEnabled: process.env.REACT_APP_ENABLE_MENTORSHIP_TAGS === "true",
    // Tutor dashboard "Post-session quizzes" section (read-only). Sub-flag of
    // mentorships, mirroring the backend's
    // qlearn.mentorship.post-session-quizzes.enabled; the section also hides
    // itself when the backend answers 404. Dark by default.
    tutorPostSessionQuizzesEnabled:
        process.env.REACT_APP_ENABLE_TUTOR_POST_SESSION_QUIZZES === "true",
    // Oversight quiz-open (contract qlearn-oversight-quiz-open-v1): sub-flag of
    // mentorships — the Open action + oversight routes render only when BOTH
    // this and mentorshipsEnabled are true, mirroring the backend's two-flag
    // gate (qlearn.mentorship.enabled + qlearn.mentorship.oversight-quiz-open).
    // Dark by default so the affordance ships with the backend flip, not
    // pointing at 404s (gate advisory F4).
    oversightQuizOpenEnabled: process.env.REACT_APP_ENABLE_OVERSIGHT_QUIZ_OPEN === "true",
    // Unsaved tutor-led practice ("Do together" on the tutor's student page):
    // sub-flag of mentorships, mirroring the backend's two-flag gate
    // (qlearn.mentorship.enabled + qlearn.mentorship.guided-practice). Dark by
    // default — absent from every .env/buildspec until the server flag flips.
    guidedPracticeEnabled: process.env.REACT_APP_ENABLE_GUIDED_PRACTICE === "true",
    // Zoom session watermark: renders a compression-robust AprilTag (tag36h11)
    // fiducial encoding the current question-id — via a private per-session
    // id-book — into the tutor's shared question view, so recorded Zoom
    // sessions become machine-indexable by question. Off unless the env flag
    // is set; only shown in tutor context. See
    // ZOOM-WATERMARK-SCOPING-2026-07-04.md + the decoder contract in
    // utils/session-fiducial/session-fiducial.js.
    sessionFiducialEnabled: process.env.REACT_APP_ENABLE_SESSION_FIDUCIAL === "true",
    // Server-authoritative in-quiz grading (in-quiz answer-egress design,
    // qlearn-unified #115; consumes QLearn-service #483's POST
    // /qlearn/quiz/{quizId}/question/{questionId}/answer). With the flag on, an
    // authed tutor-mode quiz submits each answer to the server — which records
    // it final and returns { correct, question } with the revealed key +
    // explanations — instead of grading from a client-held answer key. Off by
    // default: flag-off keeps every existing path byte-identical, so Slice C
    // can strip the key from the in-quiz payload only where this is enabled.
    serverGradingEnabled: process.env.REACT_APP_SERVER_GRADING === "true"
};

// Runtime client-config application (in-quiz egress C0; qlearn-unified #116
// resolving #115 §4.2). CRA env flags are build-time constants baked into the
// bundle, so a pinned iOS binary can never receive a flip — this lets a
// runtime fetch (GET /qlearn/client-config) enable serverGradingEnabled for
// already-shipped bundles instead. Semantics: ENABLE-ONLY on an exact
// boolean true — a malformed/absent/error payload is a no-op (fail-open to
// the built value), the env var stays a dev/test override a server false
// cannot un-set, and in-session rollback is not promised (C2 rollback = flip
// the server flag; new sessions resolve it at quiz mount).
export const applyClientConfig = (config) => {
    if (config?.serverGradingEnabled === true) {
        CONSTANTS.serverGradingEnabled = true;
    }
};